// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3orN_","calendarButtons":"ClockData_calendarButtons__1Vi41"};